<template>
  <div class="charttest">
    <!--<div style="width: 100%; height: 294px" :id="echarts" ref="echarts"></div> -->
    <div :style="{width: '100%', height: '294px'}" :id="echarts" ref="echarts"></div>
  </div>
</template>
<script>
import echarts from "echarts";
import { mapActions } from "vuex";
export default {
  name: "LineChart",
  data() {
    return {
      dataAxis1: [],
      myChart: "",
      data2: {
        invent: [],
        ultiy: [],
        design: [],
      },
    };
  },
  created() {
    this.initChartsChart();
  },
  mounted() {
     this.$nextTick(function () {
      // 图表自适应
      window.onresize = function () {
        echarts.init(document.getElementById("echarts")).resize();
      };
      this.initChartsChart()
      // this.drawRanking()
    });
  },

  methods: {
    ...mapActions("category", ["getChartData"]),
    initChartsChart() {
      let _this = this;
      let data = {
        params: {
          gid: 1,
          chartTplCode: "pa_type_grant_trend",
        },
      };
      this.getChartData({
        data: data,
        handle(res) {
          let list = res.message;
          _this.chartsdatapictwo = res.message.data;
          let listcategory = [];
          let datasubmter = [];
          let newyear = [];
          let echararr = [];
          for (var i = 0; i < _this.chartsdatapictwo.length; i++) {
            var arrindex = echararr.findIndex((item, index, arr) => {
              return item.year === _this.chartsdatapictwo[i].year;
            }); //获取下标
            if (arrindex == -1) {
              //
              echararr.push({
                year: _this.chartsdatapictwo[i].year,
                data: [_this.chartsdatapictwo[i].data],
              });
            } else {
              echararr[arrindex].data.push(_this.chartsdatapictwo[i].data);
            }
            let datatwo = [];
            let yearChartstwo = [];
            let numarr01 = [];
            let numarr02 = [];
            let numarr03 = [];
            echararr.forEach((item) => {
              let year = item.year;
              let data = item.data;
              let sum001 = 0;
              let sum002 = 0;
              let sum003 = 0;
              data.forEach((item) => {
                sum001 += item["发明专利"];
                sum002 += item["外观设计"];
                sum003 += item["实用新型"];
              });
              numarr01 = numarr01.concat(sum001);
              numarr02 = numarr02.concat(sum002);
              numarr03 = numarr03.concat(sum003);
              yearChartstwo = yearChartstwo.concat(year);
            });
            _this.dataAxis1 = yearChartstwo;
            _this.data2.invent = numarr01;
            _this.data2.design = numarr02;
            _this.data2.ultiy = numarr03;
          }
        },
      });
    },

    initChart() {
      this.myChart = echarts.init(this.$refs.echarts);
      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },

    drawCharts() {
      var myChart = echarts.init(document.getElementById(this.echarts));
      myChart.setOption({
        tooltip: {
          trigger: "axis",
        },
        legend: {
          show: true,
        },
        grid: {
          left: "0",
          right: "0",
          containLabel: true,
        },
        toolbox: {
          show: false,
        },
        color: [
          "#0095ff",
          "#33d1b1",
          "#5dbcff",
          "#ff6836",
          "#ff895d",
          "#ffb217",
          "#ffcf6d",
          "#ffe2a8",
        ],
        xAxis: [
          {
            name: "",
            type: "category",
            data: this.dataAxis1,
            axisLabel: {
              color: "#777C8B",
            },
            axisLine: {
              lineStyle: {
                color: "#33d1b1",
              },
            },
            axisTick: {
              lineStyle: {
                color: "#777C8B",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#777C8B",
            },
            axisLine: {
              lineStyle: {
                // color: '#777C8B'
                color: "#C2C2C2", //深灰
              },
            },
            axisTick: {
              lineStyle: {
                color: "#777C8B",
              },
            },
          },
        ],
        series: [
          {
            name: "发明专利",
            type: "bar",
            data: this.data2.invent,
          },
          {
            name: "实用新型",
            type: "bar",
            data: this.data2.ultiy,
          },
          {
            name: "外观专利",
            type: "bar",
            data: this.data2.design,
          },
        ],
      });
      //         //   this.myChart1.setOption(option);
    },
  },
  computed: {
    echarts() {
      return "echarts" + Math.random() * 1000;
    },
  },
  
  destroyed() {
    window.removeEventListener("resize", this.initChart, 20);
  },
  components: {},
};
</script>

<style>
.charttest{
width:100% !important;
height: 290px;
}

</style>